export const errorCodes = {
  product_on_stop: 113,
  not_delivery: 101,
  min_order: 101,
  open_at: 101,
} as const;
